import React, { useEffect, useState } from 'react'
import { SlackOutlined } from '@ant-design/icons'
import {
  GetProductDataAPI,
  GenerateBarcodeAPI,
  BaseIp,
} from '../AllAPI/AdminAPI'
import { Select, Input, Button } from 'antd'
import { toast } from 'react-toastify'
import axiosInstance from '../Utils/axiosInstance'

const { Option } = Select

const GenerateBarcode = () => {
  const selectedYear = Number(sessionStorage.getItem('year'))
  const [productList, setProductList] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [qty, setQty] = useState('')
  const [productLoading, setProductLoading] = useState(false)
  const [generateLoading, setGenerateLoading] = useState(false)

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setProductLoading(true)

        const res = await axiosInstance.get(`${GetProductDataAPI}/${selectedYear}`)
        setProductList(res.data || [])
      } catch (err) {
        console.error('Product fetch error:', err)
        toast.error('Failed to load products')
      } finally {
        setProductLoading(false)
      }
    }

    fetchProducts()
  }, [selectedYear])

  const handleGenerate = async () => {
    if (!selectedProduct) return toast.error('Please select product')

    if (!qty || Number(qty) <= 0) return toast.error('Enter valid quantity')

    try {
      setGenerateLoading(true)

      const res = await axiosInstance.post(`${GenerateBarcodeAPI}`, {
        product_id: selectedProduct,
        quantity: Number(qty),
      })

      if (res.data?.message === 'GENERATED') {
        toast.success('PDF Generated Successfully!')

        const pdfPath = res.data.pdf.replace(/\\/g, '/')
        const pdfUrl = `${BaseIp}${pdfPath}`

        window.open(pdfUrl, '_blank')
      } else {
        toast.error('Failed to generate barcode')
      }
    } catch (err) {
      console.error('Generate barcode error:', err)
      toast.error('Something went wrong')
    } finally {
      setGenerateLoading(false)
    }
  }

  return (
    <div className="mainContainer">
      <div className="header-raw">
        <h3>
          <SlackOutlined style={{ color: 'orangered' }} /> Generate Barcode
        </h3>
      </div>

      <div className="row p-2 m-0 mb-2 rounded border shadow">
        {/* Product */}
        <div className="col-12 col-md-4">
          <label>Product</label>
          <Select
            placeholder="Select Product"
            loading={productLoading}
            style={{ width: '100%' }}
            allowClear
            value={selectedProduct}
            onChange={setSelectedProduct}
          >
            {productList.map((p) => (
              <Option key={p.prod_id} value={p.prod_id}>
                {p.product_name} ({p.size})
              </Option>
            ))}
          </Select>
        </div>

        {/* Qty */}
        <div className="col-12 col-md-2">
          <label>Qty</label>
          <Input
            placeholder="Qty"
            type="number"
            value={qty}
            step="1"
            onKeyDown={(e) => {
              if (e.key === '.' || e.key === ',') {
                e.preventDefault()
              }
            }}
            onChange={(e) => setQty(e.target.value)}
          />
        </div>

        {/* Button */}
        <div className="col-12 col-md-2 d-flex align-items-end">
          <Button
            type="primary"
            onClick={handleGenerate}
            loading={generateLoading}
            disabled={!selectedProduct || !qty}
          >
            Generate Barcode
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GenerateBarcode
